/** 限制同时向服务端拉流的封面预览数量（有本地缓存的不占名额） */
const MAX_CONCURRENT = 4;
let active = 0;
const waitQueue = [];

const drain = () => {
    while (active < MAX_CONCURRENT && waitQueue.length > 0) {
        const next = waitQueue.shift();
        next();
    }
};

/**
 * 获取预览加载名额，返回 release 函数
 * @returns {Promise<() => void>}
 */
export function acquirePreviewSlot() {
    return new Promise((resolve) => {
        const grant = () => {
            active += 1;
            let released = false;
            resolve(() => {
                if (released) return;
                released = true;
                active = Math.max(0, active - 1);
                drain();
            });
        };
        if (active < MAX_CONCURRENT) {
            grant();
        } else {
            waitQueue.push(grant);
        }
    });
}
